import { type EnvironmentId, type ServerProvider } from "@cmmd-forge/contracts";
import { getStoredLocalDeviceRuntimeId } from "../../deviceRegistryIdentity";
import { useSavedEnvironmentRuntimeStore } from "../../environments/runtime/savedEnvironmentRuntimeStore";
import {
  isLocalExecutionEnvironmentId,
  resolveLocalDeviceRuntimeId,
} from "../../environments/localExecutionEnvironment";
import { readPrimaryEnvironmentDeviceRuntimeId } from "../../environments/primary/context";
import { getServerConfig } from "../../rpc/serverState";
import { resolveNewThreadProviderInventory } from "./NewThreadLanding.logic";

interface LiveProviderInventoryInput {
  readonly primaryEnvironmentId: EnvironmentId | null;
  readonly primaryServerConfig: { readonly providers: ReadonlyArray<ServerProvider> } | null;
}

export function readLiveProviderInventory(
  input: LiveProviderInventoryInput,
  environmentId: EnvironmentId,
): readonly ServerProvider[] | null {
  const localDeviceRuntimeId = resolveLocalDeviceRuntimeId({
    serverReported: readPrimaryEnvironmentDeviceRuntimeId(),
    stored: getStoredLocalDeviceRuntimeId(),
  });
  const targetIsThisMachine = isLocalExecutionEnvironmentId({
    environmentId,
    primaryEnvironmentId: input.primaryEnvironmentId,
    localDeviceRuntimeId,
  });
  return resolveNewThreadProviderInventory({
    targetEnvironmentId: environmentId,
    primaryEnvironmentId: input.primaryEnvironmentId,
    primaryServerConfig: targetIsThisMachine
      ? (getServerConfig() ?? input.primaryServerConfig)
      : input.primaryServerConfig,
    targetEnvironmentServerConfig:
      useSavedEnvironmentRuntimeStore.getState().byId[environmentId]?.serverConfig ?? null,
    localDeviceRuntimeId,
  });
}
